import type { ModuleType } from 'infrastructure/enums';

window._interactionConfirmShowedPatients =
  window._interactionConfirmShowedPatients || new Set();

interface IProps {
  patientGuid: string;
  module: ModuleType.RPM | ModuleType.CCM;
}

export const addInteractionConfirmShowedPatient = ({
  patientGuid,
  module,
}: IProps) => {
  window._interactionConfirmShowedPatients?.add(`${patientGuid}-${module}`);
};

export const isInteractionConfirmShowed = ({ patientGuid, module }: IProps) => {
  return window._interactionConfirmShowedPatients?.has(
    `${patientGuid}-${module}`,
  );
};
